import * as React from 'react'
import loadable from '@loadable/component'
import i18n from 'src/assets/messages'
import { findOne } from 'src/utils/graph/GraphExplorer'
import { Route, BrowserRouter, Switch } from 'react-router-dom'
import classNames from 'classnames'
import { InactivityDetector } from 'src/utils/InactivityDetector/index'
const Login = loadable(() => import('src/pages/auth/Login'))
const NewPassword = loadable(() => import('src/pages/auth/NewPassword'))
const NewAccountEmailConfirmation = loadable(() => import('src/pages/auth/NewAccountEmailConfirmation'))
const NewAccount = loadable(() => import('src/pages/auth/NewAccount'))
const ForgetPassword = loadable(() => import('src/pages/auth/ForgetPassword'))
const Logout = loadable(() => import('src/presentations/widgets/Logout'))
import { Storage } from 'src/utils/storage'
import Topbar from 'src/pages/common/Topbar'
const NoMatch = loadable(() => import('src/presentations/widgets/NoMatch'))
const DocumentEntities = loadable(() => import('src/pages/DocumentEntities/DocumentEntities'))
import isAuth from 'src/utils/isAuth'
const Account = loadable(() => import('src/pages/account/account'))
const Members = loadable(() => import('src/pages/account/members'))
const companies = loadable(() => import('src/pages/companies'))
const Redirection = loadable(() => import('src/pages/Redirection'))
const Redirectionsignin = loadable(() => import('src/pages/Redirection/signin'))
const Redirectionsignup = loadable(() => import('src/pages/Redirection/signup'))
const Redirectionforgetpassword = loadable(() => import('src/pages/Redirection/forget-password'))
const CreateCompany = loadable(() => import('src/pages/companies/createCompany'))
const EditWorkSpace = loadable(() => import('src/pages/companies/editCompany'))
const planComptable = loadable(() => import('src/pages/planComptable'))
const cabinets = loadable(() => import('src/pages/cabinet'))
const comptes = loadable(() => import('src/pages/compte'))
const correspondances = loadable(() => import('src/pages/correspondance'))
import 'src/assets/css/App.css'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.css'
import { parse } from 'query-string'
import CompanyDetail from './pages/company'
import Transaction from './pages/company/bank/transaction'
const DashBoardAnalyticsItemImageView = loadable(() => import('src/pages/imageview/index'))
const NavigationContentImageView = loadable(() => import('./pages/imageview/NavigationContent'))

const Dash = loadable(() => import('src/pages/dash'))
const DashAll = loadable(() => import('src/pages/dash/indexAll'))
const DashAnalyticsItem = loadable(() => import('src/pages/dash/analyticsItemPage/index'))
const DashNavigationContent = loadable(() => import('./pages/dash/analyticsItemPage/NavigationContent'))

export interface RouteConfiguration {
  path: string
  exact?: boolean
  component: React.ComponentType
  routes?: RouteConfiguration[]
}

const routes: RouteConfiguration[] = [
  {
    path: '/:language/logout',
    component: Logout,
  },
  {
    path: '/signin',
    component: Redirectionsignin,
  },
  {
    path: '/signup',
    component: Redirectionsignup,
  },
  {
    path: '/forget-password',
    component: Redirectionforgetpassword,
  },
  {
    path: '/:language/signin',
    component: Login,
  },
  {
    path: '/:language/forget-password',
    exact: true,
    component: ForgetPassword,
  },
  {
    path: '/:language/new-password/:token',
    exact: true,
    component: NewPassword,
  },
  {
    path: '/y/d/signup',
    exact: true,
    component: NewAccount,
  },
  {
    path: '/:language/signup',
    exact: true,
    component: NewAccount,
  },
  {
    path: '/:language/signup/:token',
    exact: true,
    component: NewAccountEmailConfirmation,
  },
  {
    path: '/:language/imageview/:analyticID',
    component: DashBoardAnalyticsItemImageView,
    routes: [
      {
        path: '/:language/imageview/:analyticID/document',
        exact: true,
        component: NavigationContentImageView,
      },
    ]
  },
  {
    path: '/:language/companies/:companyId',
    component: isAuth(Topbar),
    routes: [
      {
        path: '/:language/companies/:companyId/banks',
        exact: true,
        component: CompanyDetail,
      },
      {
        path: '/:language/companies/:companyId/documents',
        exact: true,
        component: CompanyDetail,
      },
      {
        path: '/:language/companies/:companyId/banks/:bankId',
        exact: true,
        component: Transaction,
      },
      {
        path: '/:language/companies/:companyId/members',
        exact: true,
        component: Members,
      },
      {
        path: '/:language/companies/:companyId/profile',
        exact: true,
        component: Account,
      },
      {
        path: '/:language/companies/:companyId/pre-trained/:categories/:id',
        exact: true,
        component: DocumentEntities,
      },
      {
        path: '/:language/companies/:companyId/dash',
        exact: true,
        component: Dash,
      },
      {
        path: '/:language/companies/:companyId/edit',
        component: EditWorkSpace,
        routes: [
          {
            path: '/:language/companies/:companyId/edit/description',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/user',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/api',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/status',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/categories',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/priorities',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/checklists',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/comments',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/inboundmail',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/security',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/dynamicname',
            exact: true,
            component: EditWorkSpace,
          },
          {
            path: '/:language/companies/:companyId/edit/setting/webview',
            exact: true,
            component: EditWorkSpace,
          },
        ],
      },
      {
        path: '/:language/companies/:companyId/dash/analytics/:analyticID',
        component: DashAnalyticsItem,
        routes: [
          {
            path: '/:language/companies/:companyId/dash/analytics/:analyticID/overview',
            exact: true,
            component: DashNavigationContent,
          },
          {
            path: '/:language/companies/:companyId/dash/analytics/:analyticID/data',
            exact: true,
            component: DashNavigationContent,
          },
          {
            path: '/:language/companies/:companyId/dash/analytics/:analyticID/validation',
            exact: true,
            component: DashNavigationContent,
          },
          {
            path: '/:language/companies/:companyId/dash/analytics/:analyticID/document',
            exact: true,
            component: DashNavigationContent,
          },
          {
            path: '/:language/companies/:companyId/dash/analytics/:analyticID/comments',
            exact: true,
            component: DashNavigationContent,
          },
          {
            path: '/:language/companies/:companyId/dash/analytics/:analyticID/information',
            exact: true,
            component: DashNavigationContent,
          },
          {
            path: '/:language/companies/:companyId/dash/analytics/:analyticID/developers',
            exact: true,
            component: DashNavigationContent,
          },
          {
            path: '/:language/companies/:companyId/dash/analytics/:analyticID/addgraph',
            exact: true,
            component: DashNavigationContent,
          },
        ]
      },

      {
        path: '*',
        component: NoMatch,
      },
    ],
  },
  {
    path: '/:language',
    component: isAuth(Topbar),
    routes: [
      {
        path: '/:language',
        exact: true,
        component: companies,
      },

      {
        path: '/:language/plan-comptable',
        exact: true,
        component: planComptable,
      },
      {
        path: '/:language/inbox',
        exact: true,
        component: DashAll,
      },
      {
        path: '/:language/cabinets',
        exact: true,
        component: cabinets,
      },
      {
        path: '/:language/comptes',
        exact: true,
        component: comptes,
      },
      {
        path: '/:language/correspondances',
        exact: true,
        component: correspondances,
      },
      {
        path: '/:language/accounts',
        exact: true,
        component: companies,
      },
      {
        path: '/:language/account',
        exact: true,
        component: Account,
      },
      {
        path: '/:language/banks-documents',
        exact: true,
        component: companies,
      },
      {
        path: '/:language/companies/add-company',
        exact: true,
        component: CreateCompany,
      },
      {
        path: '*',
        component: NoMatch,
      },
    ],
  },
  {
    path: '/',
    component: isAuth(Topbar),
    routes: [
      {
        path: '/',
        exact: true,
        component: Redirection,
      },

    ],
  },
]

/**
 * Add the sub route of the menu configuration
 * For each route, check if has sub route
 * @param {RouteConfiguration} route
 * @return {Route} Sub menu that match a route
 */
export const RouteWithSubRoutes = (route: RouteConfiguration) => {
  const renderRoute = (props: any) => {
    return <route.component {...props} routes={route.routes} />
  }
  return <Route path={route.path} render={renderRoute} />
}

interface States {
  online: boolean
  onChangeLanguage: boolean
  acc: {
    status: number
    overlayRequest: boolean
    apiActivate: string
    customActivate: string
    accountVerified: boolean | null
  }
}

class AppStudio extends React.Component<{}, States> {
  constructor(props: any) {
    super(props)
    this.state = {
      online: window.navigator.onLine,
      onChangeLanguage: false,
      acc: {
        status: 100,
        overlayRequest: false,
        apiActivate: 'false',
        customActivate: 'false',
        accountVerified: null,
      },
    }
  }

  async componentWillMount() {
    const query: any = parse(window.location.search)
    let hasChanged = false
    if (query && query.lang) {
      Storage.set('language', query.lang)
      hasChanged = true
    }

    // Remove console log in production
    if (process.env.REACT_APP_STAGE === "prod") {
      // console.log = () => {}
    }

    if (query && query.plan) {
      Storage.set('plan', query.plan)
      hasChanged = true
    }

    if (query && query.currency) {
      Storage.set('currency', query.currency)
      hasChanged = true
    }

    if (hasChanged) {
      this.setState({ onChangeLanguage: true }, () => {
        window.location.href = window.location.origin + window.location.pathname
      })
    }

    if (window.addEventListener) {
      window.addEventListener('offline', () => this.setState({ online: false }))
      window.addEventListener('online', () => this.setState({ online: true }))
    }

    const meCurrent: any = localStorage.getItem('meCurrent')
    if (meCurrent) {
      const result: any = await findOne({
        target: 'Account',
        alias: 'row',
        where: { id: JSON.parse(meCurrent).account.id },
        output: {
          id: true,
          status: true,
          accountVerified: true,
          apiActivate: true,
          customActivate: true,
        },
      })

      localStorage.setItem('apiActivate', result.row.apiActivate)
      localStorage.setItem('customActivate', result.row.customActivate)


      this.setState({ acc: { ...result.row } })
    }
  }

  render() {
    return (
      <>
        <InactivityDetector />
        {!this.state.onChangeLanguage && (
          <>
            <div className='toastChanged'>
              <ToastContainer
                position={toast.POSITION.TOP_RIGHT}
                autoClose={false}
                hideProgressBar={true}
                pauseOnHover={true}
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                draggable={true}
              />
            </div>
            {this.state.online === false && (
              <div className='WaitNetwork'>{i18n.t('waitNetork')}</div>
            )}
            {this.state.acc.status === 99 && (
              <div className='WaitNetwork'>
                Your account was disabled. Please contact support@youngapp.co
                for more details.
              </div>
            )}
            {this.state.acc.overlayRequest && (
              <div className='WaitNetwork'>
                Too Many Requests per day, rate limit exceeded on your account.
                Please contact support@youngapp.co for more details.
              </div>
            )}
            {this.state.acc.status === 101 && (
              <div className='WaitNetwork'>
                Oops, payment failed, please update your card details and try
                one more time or contact support@youngapp.co.
              </div>
            )}

            <div
              className={classNames({
                'container-app':
                  !this.state.online ||
                  this.state.acc.status === 102 ||
                  this.state.acc.status === 99 ||
                  this.state.acc.overlayRequest ||
                  this.state.acc.status === 101,
              })}
            >
              {/* TODO: replace hard coded api key by runtime environment variable */}
              {/* <AppTourProvider> */}
              <BrowserRouter>
                <Switch>
                  {routes.map((route, index) => (
                    <RouteWithSubRoutes key={index} {...route} />
                  ))}
                  <Route path='*' component={NoMatch} />
                </Switch>
              </BrowserRouter>
              {/* <AppTour key={Math.random()} /> */}
              {/* </AppTourProvider> */}
            </div>
          </>
        )}
      </>
    )
  }
}

export default AppStudio


// WEBPACK FOOTER //
// ./src/App.tsx